import PaymentMethods from './payment-methods.vue';

export default PaymentMethods;
